import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useMobilityDelete } from '../model/MobilityQuery';

interface MobilityDeleteButtonProps {
  mobilityId: Id;
}

export function MobilityDeleteButton({ mobilityId }: MobilityDeleteButtonProps) {
  const mutation = useMobilityDelete(mobilityId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
